import { v4 } from 'uuid';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var TRACKER_SERVER_URLS = {
    JIKE: 'https://tr.ruguoapp.com/sa.gif',
    XIAOYUZHOU: 'https://tr.xiaoyuzhoufm.com/sa.gif',
    DEFAULT: 'https://track.midway.run/sa.gif',
};

var getItem = function (sKey) {
    return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
        encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
};
var setItem = function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
        return false;
    }
    var sExpires = '';
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires =
                    vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                break;
            case String:
                sExpires = '; expires=' + vEnd;
                break;
            case Date:
                sExpires = '; expires=' + vEnd.toUTCString();
                break;
        }
    }
    document.cookie =
        encodeURIComponent(sKey) +
            '=' +
            encodeURIComponent(sValue) +
            sExpires +
            (sDomain ? '; domain=' + sDomain : '') +
            (sPath ? '; path=' + sPath : '') +
            (bSecure ? '; secure' : '');
    return true;
};
var hasItem = function (sKey) {
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
};

var shortUUID = function () {
    return v4().replace(/-/g, '');
};
var hashCode = function (str) {
    if (typeof str !== 'string') {
        return 0;
    }
    var hash = 0;
    var char = null;
    if (str.length == 0) {
        return hash;
    }
    for (var i = 0; i < str.length; i++) {
        char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return hash;
};
var utf8Encode = function (string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '';
    var start;
    var end;
    var stringl = 0;
    var n;
    start = end = 0;
    stringl = string.length;
    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) {
            end++;
        }
        else if (c1 > 127 && c1 < 2048) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        }
        else {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) {
        utftext += string.substring(start, string.length);
    }
    return utftext;
};
// see https://developer.mozilla.org/zh-CN/docs/Glossary/Base64#%E6%96%B9%E6%A1%88_1_%E2%80%93_%E7%BC%96%E7%A0%81%E4%B9%8B%E5%89%8D%E8%BD%AC%E4%B9%89escape%E5%AD%97%E7%AC%A6%E4%B8%B2
var toBase64 = function (data) {
    if (typeof btoa === 'function') {
        return btoa(encodeURIComponent(data).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt('0x' + p1, 16));
        }));
    }
    data = String(data);
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1;
    var o2;
    var o3;
    var h1;
    var h2;
    var h3;
    var h4;
    var bits;
    var i = 0;
    var ac = 0;
    var enc = '';
    var tmpArr = [];
    if (!data) {
        return data;
    }
    data = utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = (o1 << 16) | (o2 << 8) | o3;
        h1 = (bits >> 18) & 0x3f;
        h2 = (bits >> 12) & 0x3f;
        h3 = (bits >> 6) & 0x3f;
        h4 = bits & 0x3f;
        tmpArr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);
    enc = tmpArr.join('');
    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};

var _config = {
    distinctId: '',
    project: '',
    serverUrl: TRACKER_SERVER_URLS.DEFAULT,
    debug: false,
    rawObject: false,
    rawObjectKeys: [],
};
var _defaultProperties = {};
var IS_SERVER = typeof window === 'undefined';
var interceptors = [];
var currentPage = {};
var shouldUseRawObject = function (key) {
    return _config.rawObjectKeys.includes(key);
};
var addRawObjectKeys = function (key) {
    _config.rawObjectKeys.push(key);
};
var enableDebug = function () {
    _config = __assign(__assign({}, _config), { debug: true });
};
var config = function (config) {
    _config = __assign(__assign({}, _config), config);
};
var sendViaImg = function (project, data) {
    var base64Data = encodeURIComponent(toBase64(JSON.stringify(data)));
    var crc = hashCode(base64Data);
    var sendURL = _config.serverUrl + "?project=" + project + "&data=" + base64Data + "&crc=" + crc;
    var image = new Image();
    image.src = sendURL;
    image.onload = function () {
        image.remove();
    };
};
var sendViaFetch = function (project, data) {
    var base64Data = encodeURIComponent(toBase64(JSON.stringify(data)));
    var crc = hashCode(base64Data);
    var sendURL = _config.serverUrl + "?project=" + project + "&data=" + base64Data + "&crc=" + crc;
    fetch(sendURL);
};
var flatNestedObject = function (path, ob) {
    var toReturn = {};
    for (var key in ob) {
        if (!Object.prototype.hasOwnProperty.call(ob, key))
            continue;
        if (typeof ob[key] === 'object' && shouldUseRawObject(path + "." + key) === false) {
            var flatObject = flatNestedObject(path + "." + key, ob[key]);
            for (var x in flatObject) {
                if (!Object.prototype.hasOwnProperty.call(flatObject, x))
                    continue;
                if (flatObject[x] !== undefined) {
                    toReturn[key + '$$' + x] = flatObject[x];
                }
            }
        }
        else {
            toReturn[key] = ob[key];
        }
    }
    return toReturn;
};
var getDistinctId = function () {
    var distinctId = _config.distinctId;
    if (!distinctId) {
        if (IS_SERVER) {
            distinctId = shortUUID();
        }
        else {
            if (hasItem('_jid')) {
                distinctId = getItem('_jid') || '';
            }
            else {
                var newId = shortUUID();
                setItem('_jid', newId, Infinity, '/');
                distinctId = newId;
            }
        }
        config({ distinctId: distinctId });
    }
    return distinctId;
};
var pageInfoInterceptor = function (props) {
    if (currentPage) {
        return __assign(__assign({}, props), { properties: __assign(__assign({}, props.properties), { web_info: __assign(__assign({}, props.properties.web_info), { page_name: currentPage.pageName }), page_info: __assign(__assign({}, props.properties.page_info), { id: currentPage.pageId }) }) });
    }
    else {
        return props;
    }
};
var addInterceptor = function (interceptor) {
    interceptors.unshift(interceptor);
};
var getUtmSource = function () {
    if (_defaultProperties['$utm_source'] === undefined)
        if (URLSearchParams && !IS_SERVER) {
            var searchParams = new URLSearchParams(window && window.location.search);
            _defaultProperties['$utm_source'] = searchParams.get('utm_source');
        }
    return _defaultProperties['$utm_source'];
};
var track = function (event, prop, options) { return __awaiter(void 0, void 0, void 0, function () {
    var data, dataToChange, _i, interceptors_1, interceptor, err_1, finalData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = {
                    distinct_id: getDistinctId(),
                    lib: { $lib: 'js', $lib_method: 'code', $lib_version: '1.13.14' },
                    properties: __assign({}, prop),
                    type: 'track',
                    event: event,
                    time: new Date().valueOf(),
                    _track_id: shortUUID(),
                };
                if (IS_SERVER === false) {
                    data.properties.$ua = navigator && navigator.userAgent;
                }
                data.properties.$utm_source = getUtmSource();
                dataToChange = __assign({}, data);
                _i = 0, interceptors_1 = interceptors;
                _a.label = 1;
            case 1:
                if (!(_i < interceptors_1.length)) return [3 /*break*/, 6];
                interceptor = interceptors_1[_i];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, interceptor(dataToChange)];
            case 3:
                dataToChange = (_a.sent()) || data;
                return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                console.error(err_1);
                return [3 /*break*/, 5];
            case 5:
                _i++;
                return [3 /*break*/, 1];
            case 6:
                finalData = __assign(__assign({}, dataToChange), { properties: _config.rawObject
                        ? dataToChange.properties
                        : flatNestedObject('properties', __assign({}, dataToChange.properties)) });
                _config.debug && console.info(finalData);
                if (IS_SERVER) {
                    sendViaFetch(_config.project, finalData);
                }
                else {
                    sendViaImg(_config.project, finalData);
                }
                return [2 /*return*/];
        }
    });
}); };
var pageView = function (pageName, pageId, props) {
    if (props === void 0) { props = {}; }
    var propsToChange = __assign({}, props);
    currentPage = {
        pageName: pageName,
        pageId: pageId,
    };
    propsToChange = __assign(__assign({}, propsToChange), { web_info: __assign(__assign({}, propsToChange.web_info), { page_name: pageName, action: 'view' }) });
    track('h5_page_view', propsToChange);
};
var useJA = function () {
    return {
        track: track,
        pageView: pageView,
    };
};

export { TRACKER_SERVER_URLS, addInterceptor, addRawObjectKeys, config, enableDebug, flatNestedObject, getDistinctId, pageInfoInterceptor, pageView, sendViaFetch, sendViaImg, track, useJA };
